const InputType = {
	DownVote: {
		key: 'downVote',
		singularKey: 'downvote',
		pluralKey: 'downvotes',
	},
	UpVote: {
		key: 'upVote',
		singularKey: 'upvote',
		pluralKey: 'upvotes',
	},
	Comment: {
		key: 'comment',
		singularKey: 'comment',
		pluralKey: 'comments',
	},
	Quantity: {
		key: 'quantity',
		singularKey: 'quantity',
		pluralKey: 'quantities',
	},
	Add: {
		key: 'add',
		singularKey: 'add',
		pluralKey: 'adds',
	},
};

export default InputType;
